import styled from '@emotion/styled';

export const TabletsWrapper = styled.div` 
  display: grid;
  grid-template-columns: 1fr min-content;
  gap: 8px;
  padding: 10px;
`;
